var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48667 18.5844L4.90088 19.9986L20.4572 4.44229L19.043 3.02808L16.6285 5.44257C15.2073 4.83583 13.6431 4.49998 12 4.49998C7 4.49998 2.73 7.60998 1 12C1.81175 14.0599 3.18274 15.8379 4.92596 17.1451L3.48667 18.5844ZM7.63386 14.4372L9.145 12.9261C9.05085 12.6346 9 12.3233 9 12C9 10.34 10.34 8.99998 12 8.99998C12.3234 8.99998 12.6346 9.05083 12.9261 9.14498L14.4372 7.63385C13.716 7.23016 12.8847 6.99998 12 6.99998C9.24 6.99998 7 9.23998 7 12C7 12.8847 7.23017 13.716 7.63386 14.4372Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5C10.8532 19.5 9.7448 19.3364 8.69664 19.0312L10.8589 16.869C11.2254 16.9547 11.6075 17 12 17C14.76 17 17 14.76 17 12C17 11.6074 16.9547 11.2254 16.869 10.8589L20.0531 7.67478C21.3323 8.8686 22.3471 10.3431 23 12C21.27 16.39 17 19.5 12 19.5Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.50bffb18328c183201891de063404921.svg";
export { ForwardRef as ReactComponent };